<template>
  <div
    v-if="state.open"
    class="fixed top-0 bottom-0 left-0 right-0 z-50"
    style="background: rgba(0, 0, 0, 0.3)"
    @click.self="close"
    @keydown.esc="close"
  >
    <div class="mx-auto container h-full md:h-auto" style="max-width: 960px">
      <div
        ref="modalPanel"
        class="h-full md:h-[80vh] md:max-h-[700px] md:mt-12 outline-none"
        tabindex="-1"
      >
        <HelpChatPanel class="h-full" show-expand @close="close" @expand="openPopup" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { onUnmounted, reactive, ref, watch, nextTick } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import HelpChatPanel from './HelpChatPanel.vue';

const router = useRouter();
const store = useStore();

const state = reactive({
  open: false,
});

const modalPanel = ref(null);
let previousActiveElement = null;

const open = () => {
  previousActiveElement = document.activeElement;
  state.open = true;

  nextTick(() => {
    if (modalPanel.value) {
      modalPanel.value.focus();
    }
  });
};

const close = () => {
  state.open = false;

  nextTick(() => {
    if (previousActiveElement && typeof previousActiveElement.focus === 'function') {
      previousActiveElement.focus();
    }
  });
};

function openPopup() {
  const url = router.resolve({ name: 'Help Chat Window' }).href;
  const popup = window.open(url, 'stc-help-chat', 'popup,width=960,height=720');
  if (!popup) return;
  popup.focus();
  close();
}

watch(() => state.open, (isOpen) => {
  store.commit('save', { helpChatOpen: isOpen });
  if (isOpen) {
    document.addEventListener('keydown', handleEscape);
  } else {
    document.removeEventListener('keydown', handleEscape);
  }
});

onUnmounted(() => {
  document.removeEventListener('keydown', handleEscape);
  if (store.state.helpChatOpen) store.commit('save', { helpChatOpen: false });
});

const handleEscape = (e) => {
  if (e.key === 'Escape') {
    close();
  }
};

defineExpose({
  open,
  close,
});
</script>
